module.exports = __webpack_public_path__ + "static/media/057-left.34bd6113.svg";